<div *ngIf="isScrolled" class="header-sticky-background"></div>
<div class="header" [ngClass]="{ sticky: isScrolled }">
  <div *ngIf="isMobile" class="menu-icon-wrapper">
    <i #menuIcon class="fas fa-bars" tabindex="0" (click)="toggleMobileMenu()" (keydown)="toggleMobileMenu($event)"></i>
  </div>

  <div class="logo-wrapper">
    <a class="logo" [routerLink]="getHomeLink()" routerLinkActive="is-active" (click)="hideMobileMenu()">BG Fashion</a>
  </div>

  <div *ngIf="!isMobile" class="pages-wrapper" (click)="hideHeaderMenu()" (mouseleave)="hideHeaderMenu()">
    <a
      *ngFor="let page of pages"
      class="page"
      (mouseenter)="showHeaderMenu(page)"
      [routerLink]="getLink(page.category)"
      routerLinkActive="is-active"
    >
      {{ page.category | titlecase }}
    </a>
    <app-header-menu
      [@menuAnimation]
      *ngIf="currentHoveredPage?.menuCategories?.length"
      [category]="currentHoveredPage.category"
      [subcategories]="currentHoveredPage.menuCategories"
      [imageUrl]="currentHoveredPage.menuImageUrl"
    ></app-header-menu>
  </div>

  <div class="cart-wrapper">
    <a [routerLink]="getFavoritesLink()" routerLinkActive="is-active">
      <i class="fas fa-heart"></i>
      <app-counter [count]="getFavoriteProductsCount()"></app-counter>
    </a>
    <a [routerLink]="getCartLink()" routerLinkActive="is-active">
      <i class="fas fa-shopping-cart"></i>
      <app-counter [count]="getCartProductsCount()"></app-counter>
    </a>
  </div>
</div>

<app-header-mobile-menu
  #mobileMenu
  *ngIf="isMobile && isMobileMenuOpen"
  [@mobileMenuAnimation]
  [pages]="pages"
  (linkClicked)="hideMobileMenu()"
></app-header-mobile-menu>

<div *ngIf="currentHoveredPage?.menuCategories?.length || isMobileMenuOpen" class="black-overlay"></div>
